/**
 * FormatNumber:
 * - Create a format for numbers to transform number in US currency.
 */
 function FormatNumber(number, isCurrency){

    let options = { style: 'currency', currency: 'USD' };
    let numberFormat = new Intl.NumberFormat('es-CO', isCurrency ? options : "");
    return numberFormat.format(number)
}
export { FormatNumber }